import { GetterTree, MutationTree } from "vuex";
import { RootState, SearchState } from "@/store/types";

const data: SearchState = {
  searches: {},
};

const getters: GetterTree<SearchState, RootState> = {
  searches(state) {
    return state.searches;
  },
};

const mutations: MutationTree<SearchState> = {
  setSearch(state, payload) {
    state.searches[payload.type] = payload.data;
  },
};

export const searches = { state: data, getters, mutations };
